<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyCharges"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.punto_venta"
          :disabled="pagination.showLoadingState"
          :elements="puntosDeVenta"
          keyField="id"
          name="puntoVenta"
          textField="nombre"
          wrapperClass="a-input-wrapper-row width-250-px"
          @input="setSelectedPtoVta($event)"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.invoiceStates"
          keyField="id"
          name="estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.buscar"
          :disabled="pagination.showLoadingState"
          name="buscar"
          placeholder="Razón Social"
          type=""
          wrapperClass="a-input-wrapper-row"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <div class="display-flex-row margin-left-auto">
        <form
          autocomplete="off"
          class="m-form-row"
          name="download-csv-form"
          @submit.prevent="readExportarComprobantesByPuntosVenta"
        >
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="pagination.showLoadingState || !invoices.length"
          />
        </form>
        <form
          autocomplete="off"
          class="m-form-row margin-left-small"
          name="download-pdf-form"
          @submit.prevent="openDownloadPdfsModal"
        >
          <AtomButtonPrimary
            :button-primary="buttonPdf"
            :disabled="pagination.showLoadingState || !invoices.length"
          />
        </form>
      </div>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="invoices.length">
          <th
            class="text-align-rigth"
            width="15%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thNumber') }}
          </th>
          <th
            class="text-align-rigth"
            width="10%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thDate') }}
          </th>
          <th
            class="text-align-rigth"
            width="15%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thClient') }}
          </th>
          <!--<th
            class="text-align-center"
            width=""
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thCountry') }}
          </th>-->
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thAmount') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thTaxAmount') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thToTal') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            {{ $t('mEditionBillingMySalesInvoicesHistory.table.thRecord') }}
          </th>
        </tr>
        <tr
          v-for="(invoice, index) in invoices"
          :key="index"
          class="row-data"
        >
          <td class="text-align-center text-white-space-nowrap">
            <a
              class="sale-state text-color"
              :href="`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.mySales.subject')}/${invoice.venta}/${$t('mEditionMenu.billing.mySales.children.invoice.subedition')}/${invoice.id}`"
              @click.prevent="gotToInvoice(invoice)"
            >
              <span>{{ invoice.numero }}</span><br>
              <small :class="$filters.getInvoiceStateValue(invoice.estado.estado, 'class')">
                {{ $filters.getInvoiceStateValue(invoice.estado.estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(invoice.fecha).format('D MMM YYYY') }}
          </td>
          <td class="break-word text-align-center">
            <span class="display-flex-column">
              <span>{{ invoice.receptor.razon_social }}</span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                {{ invoice.receptor.email }}
              </small>
            </span>
          </td>
          <!--<td class="break-word text-align-center">
            <span
              v-if="invoice.receptor_provincia"
              class="display-flex-column"
            >
              <span>{{ invoice.receptor_pais }},</span>
              <span class="font-size-small">{{ invoice.receptor_provincia }}</span>
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>-->
          <td class="text-align-center">
            <span v-if="invoice.neto">
              {{invoice.divisa_simbolo}} {{ (invoice.neto) }}
              <span class="text-color-black-35">{{ invoice.divisa }}</span>
            </span>
            <span v-else>
              {{invoice.divisa_simbolo}}
              {{(0).toFixed(2)}}
              <span class="text-color-black-35">{{ invoice.divisa }}</span>
            </span>
          </td>
          <td class="text-align-center">
            <span class="display-flex-column">
              <span v-if="invoice.monto_impuesto">{{invoice.divisa_simbolo}} {{ invoice.monto_impuesto }} <span class="text-color-black-35">{{ invoice.divisa }}</span></span>
              <span v-else>{{invoice.divisa_simbolo}} {{ (0).toFixed(2) }} <span class="text-color-black-35">{{ invoice.divisa }}</span></span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                <span v-if="invoice.impuesto">{{ `(${invoice.tipo_impuesto})` }} {{ invoice.impuesto }}%</span>
              </small>
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="invoice.total">{{invoice.divisa_simbolo}}  {{ (invoice.total) }} <span class="text-color-black-35">{{ invoice.divisa }}</span></span>
            <span v-else>{{invoice.divisa_simbolo}}  {{ (0).toFixed(2) }} <span class="text-color-black-35">{{ invoice.divisa }}</span></span>
          </td>
          <td class="text-align-center" @mouseover="setTooltip(invoice.tipo_nombre)">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.record"
              :element="invoice"
              @gotToSaleRecord="gotToInvoice(invoice)"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionBillingMySalesInvoicesHistory',

  components: {
    MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        record: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToSaleRecord',
          tooltip: 'Ver Comp.',
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionBillingMySalesInvoicesHistory.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonPdf: {
        action: 'Descargar PDFs',
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-secondary a-button-billing-secondary',
          component: 'MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMySalesInvoicesHistory.buttonSecondary.filterText'),
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingMySalesInvoicesHistory.tooltip.restart'),
          type: 'button'
        }
      },

      filter: {
        buscar: '',
        punto_venta: [],
        estado: [],
        divisa: [],
        pais: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      puntosDeVenta: [],

      showLoadingState: true,

      simpleFilter: {
        buscar: '',
        estado: '',
        punto_venta: '0',
        periodo: 0
      },

      invoices: []
    }
  },

  created () {
    this.readPuntosVenta()
  },

  methods: {
    gotToInvoice (invoice) {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.mySales.subject')}/${invoice.venta}/${this.$t('mEditionMenu.billing.mySales.children.invoice.subedition')}/${invoice.id}`)
    },

    readComprobantesByPuntoVenta () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('comprobante', 'readComprobantesByPuntoVenta', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.invoices = response.data.invoices
            this.pagination.currentQuantity = this.invoices.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.invoices = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readExportarComprobantesByPuntosVenta () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('comprobante', 'readExportarComprobantesByPuntosVenta', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingMySalesInvoicesHistory.files.invoices')}-${this.$moment().format('YYYYMMDD')}-${this.$moment().unix()}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingMySalesInvoicesHistory', 'readExportarComprobantes', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingMySalesInvoicesHistory', 'readExportarComprobantes', 'error', 'a-alert-danger')
          })
      }
    },

    openDownloadPdfsModal () {
      this.$modal.showModal(
        'MoleculeEditionBillingMySalesInvoicesHistoryModalDownloadPdfs',
        {
          academiaId: this.$store.getters.getAcademyData.id,
          filterRef: this.filter,
          simpleFilterRef: this.simpleFilter
        }
      )
    },

    readPuntosVenta () {
      this.$services.read('puntoVenta', 'readPuntosVenta', {}, [this.$store.getters.getAcademyData.id, 0])
        .then(response => {
          this.puntosDeVenta = response.data
          this.puntosDeVenta.unshift({ id: '0', nombre: this.$t('mEditionBillingMySalesInvoicesHistory.selectSalesMethods.firstOption') })
          this.readComprobantesByPuntoVenta()
        })
        .catch(error => {
          console.log(error)
        })
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        buscar: '',
        punto_venta: [],
        estado: [],
        divisa: [],
        pais: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        buscar: '',
        estado: '',
        punto_venta: '0',
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter) {
      if (this.simpleFilter.buscar !== '') {
        advancedFilter.buscar = this.simpleFilter.buscar
      } else {
        advancedFilter.buscar = ''
      }
      if (advancedFilter.estado.length > 0) {
        this.simpleFilter.estado = advancedFilter.estado[0]
      } else {
        this.simpleFilter.estado = ''
      }
      if (advancedFilter.fecha_desde !== '' || advancedFilter.fecha_hasta !== '') {
        this.simpleFilter.periodo = ''
      } else {
        this.simpleFilter.periodo = 0
      }
      advancedFilter.punto_venta = this.simpleFilter.punto_venta === '0' ? [] : [this.simpleFilter.punto_venta]
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (this.simpleFilter.buscar === '' || this.simpleFilter.buscar.length >= 3) {
        if (this.simpleFilter.punto_venta === '' || this.simpleFilter.punto_venta === '0') {
          this.simpleFilter.punto_venta = '0'
        } else {
          this.filter.punto_venta.push(this.simpleFilter.punto_venta)
        }

        this.filter.buscar = this.simpleFilter.buscar

        if (this.simpleFilter.periodo === '') {
          this.simpleFilter.periodo = ''
        } else {
          this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
          this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
        }

        if (this.simpleFilter.estado !== '') {
          this.filter.estado.push(this.simpleFilter.estado)
        } else {
          this.filter.estado = []
        }

        this.setPaginationCurrentPage(1)
      }
    },

    setTooltip (name) {
      this.buttonIconRounded.record.tooltip = name ? `Ver ${name}` : 'Ver comp.'
    },

    setSelectedPtoVta (idPv) {
      this.simpleFilter.punto_venta = idPv
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readComprobantesByPuntoVenta()
    }
  }
}
</script>
